import React from 'react';

import { Modal, Select, Button } from '../..';

import styles from './index.module.css';

export const SetAssignAdminModal = ({ visible, onCancel, title, isValid, handleSubmit, users }) => {
  return (
    <Modal visible={visible} onCancel={onCancel} closable width={580} title={title}>
      <div className={styles.modalContent}>
        <p className={styles.modalDescription}>
          Select a new administrator for this organization from the list below. Only users with administrator privileges are available for selection. If the administrator you are looking for is not listed, please ensure they have been assigned an administrator role within the organization
        </p>
        <form className={styles.modalForm} onSubmit={handleSubmit}>
          <div className={styles.selectUser}>
            Select Admin
            <Select name='admin' options={users}
              getPopupContainer={() => document.body} />
          </div>

          <div className={styles.modalBtns}>
            <div>
              <Button myClassName={styles.navigationBtn} onClick={onCancel}>
                Cancel
              </Button>
            </div>
            <div>
              <Button myClassName={styles.navigationBtn} type='submit' disabled={!isValid}>
                Assign Admin
              </Button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};
